<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-10">
            <div class="d-flex">
                <div>
                    <div class="header-content">
                        Content
                    </div>
                    <div class="sub-content mt-3">
                        Here you can update the privacy policy and terms of service.
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>
    <div class="row ml-0" *ngIf="!isEditForm">
        <div class="col-1"></div>
        <div class="col-5 my-4" id="user-toggle">
            <mat-button-toggle-group [(ngModel)]="currentUserType" style="width: 350px !important;">
                <mat-button-toggle value="Mentor" disableRipple>Mentor</mat-button-toggle>
                <mat-button-toggle value="Supporter" disableRipple>Supporter</mat-button-toggle>
                <mat-button-toggle value="User" disableRipple>User</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="col-5">
        </div>
    </div>
    <div class="row mr-0 pb-2 pt-4" *ngIf="isEditForm">
        <div class="col-1"></div>
        <div class="col-7 d-flex align-items-start">
            <mat-icon class="font-20">keyboard_arrow_left</mat-icon>
            <span class="cursor font-weight-light font-14" (click)="isEditForm=false">Back</span>
        </div>
    </div>
    <div class="bg-grey" style="height: 100vh;">
        <div class="row ml-0 pt-4 font-14" *ngIf="!isEditForm">
            <div class="col-1"></div>
            <div class="col-4 my-4">
                <div class=" card d-flex shadow-sm p-4 border-0" style="border-radius: 7px;">
                    <div class="d-flex justify-content-between">
                        <div class="">Privacy Policy</div>
                        <div class="font-13 cursor primary-btn-txt" (click)="getContent(true)">Edit</div>
                    </div>
                </div>
                <div class=" card d-flex shadow-sm p-4 border-0 mt-3" style="border-radius: 7px;">
                    <div class="d-flex justify-content-between">
                        <div class="">Terms of Service</div>
                        <div class="font-13 cursor primary-btn-txt" (click)="getContent(false)">Edit</div>
                    </div>
                </div>
            </div>
            <div class="col-6">
            </div>
        </div>
        <div class="row ml-0 pt-4 font-14" *ngIf="isEditForm">
            <div class="col-1"></div>
            <div class="col-7 my-4">
                <div class="card shadow-sm border-0 p-4" style="height: calc( 100vh - 300px);
                min-height: 335px;">
                    <div class="card-head font-weight-bold font-15 mb-3">
                        <span *ngIf="isPolicy"> Privacy Policy</span>
                        <span *ngIf="!isPolicy">Terms of Service</span>
                    </div>
                    <div class="card-content h-100">
                        <textarea class="form-control font-14 border-0 p-0 h-100" placeholder="Type to add" [(ngModel)]="currentContent"></textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-end my-3">
                    <button class="btn d-flex justify-content-center align-items-center ml-3 primary-bg text-white" style="width:30%;height: 50px" (click)="updateContent()">update</button>
                </div>
            </div>
            <div class="col-6">
            </div>
        </div>
    </div>
</div>